export const DEFAULT_GROUPING = 'date';
export const DEFAULT_FILTERS = {
  group: [DEFAULT_GROUPING],
  direction: 'desc',
  sortby: 'clicks',
};
export const REPORTS_REDUCER_NAMES = {
  REFERRAL_PROGRAM: 'referral_program',
};
